// ============================================================================
// view.fuelSupply - receipt-backed no-server-read surface
// ============================================================================
// The direct /fuel-supply route mounts FuelSupplyWebform without FuelingHub or
// Header. It has no server READ on render: its shared offline-submit path owns
// explicit user/queue mutation commands only. The independent receipt and
// source-inventory proof pin that claim; this is intentionally not an empty
// catalog resource.
//
// This declaration records the disposition only. The separate reviewed
// boot-release ledger and release receipt, not this no-read fact, authorize
// independent boot timing.
// ============================================================================

import type {NoServerReadSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: NoServerReadSurfaceDeclaration = Object.freeze({
  surface: 'view.fuelSupply',
  disposition: 'no-server-read',
});

export default declaration;
